"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonEntityAmpersandRegex = void 0;
exports.nonEntityAmpersandRegex = /&(?![A-Za-z]+;|#\d+;)/g;
//# sourceMappingURL=constants.js.map